import { useLocalStorage } from "usehooks-ts";

import { useUser } from "@components/user-context";

export const useIsDarkMode = () => {
  const { user } = useUser();
  const [isDarkMode, setIsDarkMode] = useLocalStorage("isDarkMode", false);
  if (user?.featureFlags.enableDashboardV2) {
    return [isDarkMode, setIsDarkMode] as const;
  }

  // Dark mode is not enabled if featureFlags.enableDashboardV2 is not enabled
  // TODO: Remove this logic once Northbeam 2.0 is the only available UI
  return [false, setIsDarkMode] as const;
};
